<script setup lang="ts">
import type { Hub } from '@/data/Hubs/types'
import { RouterLink } from 'vue-router'
import HubCard from './HubCard.vue'

defineProps<{ hubs: Hub[] }>()
</script>

<template>
  <nav
    aria-label="Hubs List"
    class="grid w-full grid-cols-1 gap-1"
  >
    <RouterLink
      v-for="hub in hubs"
      :key="hub.id"
      data-test="hub-link"
      class="rounded-2xl"
      :to="{ name: 'Hub', params: { hubId: hub.id } }"
    >
      <HubCard :hub="hub" />
    </RouterLink>
  </nav>
</template>
